import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}><path d="M19 32V16l14 8z" /></svg>);